/**
 * ALIS wordmark — flask icon + "ALIS", the same mark the app bar shows.
 * Used where a standalone logo is needed on dark full-bleed pages (How ALIS Works tour).
 */
import { ScienceOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { APP_NAME } from '../../constants/config';

interface AlisWordmarkProps {
  /** Icon size in px; the text scales with it. */
  size?: number;
  sx?: SxProps<Theme>;
}

export default function AlisWordmark({ size = 30, sx }: AlisWordmarkProps) {
  return (
    <Box
      role="img"
      aria-label={APP_NAME}
      sx={[{ display: 'flex', alignItems: 'center', gap: 0.75, color: 'common.white' }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      <ScienceOutlined sx={{ fontSize: size }} />
      <Typography component="span" sx={{ fontWeight: 800, fontSize: size * 0.9, letterSpacing: '0.12em', lineHeight: 1 }}>
        {APP_NAME}
      </Typography>
    </Box>
  );
}
